import React, { FC, useCallback, useEffect, useState } from 'react'
import 'react-h5-audio-player/lib/styles.css'
import { pdfjs } from 'react-pdf'
import { useDispatch } from 'react-redux'
import { RouteComponentProps, useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'
import { get } from 'src/apis/apiService'
import { setPageTitle, setPreviousPage } from 'src/ducks/onDemand'
import routes from 'src/routes'
import Amplitude from 'src/utils/amplitudeHelper'
import { ON_DEMAND_APIS } from '../../../apis/onDemandApi'
import { Loader } from '../../shared/Loader'
import { VideoPresentation } from '../VideoPresentation/VideoPresentation'
pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.js'

export interface VideoSubmissionType {
  id?: number
  title?: string
  presenter_email?: string
  presenting_submitter_name?: string
  area_of_interest?: string
  submission_video?: {
    vimeo_id: string
  }
}

export const VideoPresentationContainer: FC<RouteComponentProps> = ({ match }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const [video, setVideo] = useState<VideoSubmissionType>({})
  const [pageLoading, setPageLoading] = useState<boolean>(false)

  const videoId = match.params['videoId']

  useEffect(() => {
    dispatch(setPageTitle('How I Do It'))
    dispatch(setPreviousPage(routes.onDemandVideo))
  }, [dispatch])

  const getVideo = useCallback(() => {
    setPageLoading(true)
    get(
      ON_DEMAND_APIS.GET_VIDEO(videoId),
      (result) => {
        setPageLoading(false)
        if (result.success) {
          const videoResult: VideoSubmissionType = result.video
          setVideo(videoResult)
          Amplitude.viewVideoPresentation(videoResult)
        } else {
          toast('This video does not exist', { toastId: 'video-not-exist' })
          history.push(routes.onDemand)
        }
      },
      (error) => {
        setPageLoading(false)
        toast('Unable to display this video. Please try again later.')
        history.push(routes.onDemand)
        console.error(error)
      }
    )
  }, [videoId, history])

  useEffect(() => {
    getVideo()
  }, [getVideo])

  const renderVideo = () => {
    return <VideoPresentation video={video} />
  }

  return (
    <Loader fullPage loading={pageLoading}>
      {renderVideo()}
    </Loader>
  )
}
